import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SalesCenter(props) {
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "SalesCenter",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SalesCenter",
      "data-tidal-icon-meta": "miscellaneous",
      viewBox: "0 0 36 32",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M2.5.295A2.505 2.505 0 0 0 .563 4.376L12 18.353v4.943c0 .632.294 1.225.8 1.6l4 3c.094.07.187.132.294.182A10.94 10.94 0 0 1 16 23.295c0-5.312 3.762-9.743 8.775-10.775l6.662-8.143c.613-.75.738-1.782.325-2.657A2.493 2.493 0 0 0 29.5.295h-27Z",
            opacity: ".4"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M27 32.295a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-1.494-10.812v.006c0 .025 0 .119.3.281.35.188.844.325 1.494.513h.012c.582.162 1.32.375 1.907.719.637.375 1.25 1.006 1.281 2.018.031 1.138-.606 1.9-1.356 2.307a3.871 3.871 0 0 1-1.144.387v.675c0 .55-.45 1-1 1s-1-.45-1-1v-.712a12.528 12.528 0 0 1-1.481-.413c-.106-.037-.213-.069-.313-.1a.998.998 0 1 1 .594-1.906c.125.037.244.075.363.112.712.225 1.274.407 1.868.425.419.013.863-.068 1.157-.225a.692.692 0 0 0 .25-.206.46.46 0 0 0 .062-.281c0-.088-.012-.188-.294-.35-.331-.194-.806-.338-1.45-.519l-.112-.031c-.556-.156-1.238-.35-1.788-.644-.619-.331-1.287-.919-1.35-1.919-.075-1.175.625-1.93 1.363-2.325.356-.193.75-.318 1.125-.393v-.607c0-.55.45-1 1-1s1 .45 1 1v.588c.393.056.768.144 1.119.231a1 1 0 1 1-.482 1.944c-.581-.144-1.137-.25-1.65-.256-.387-.007-.85.08-1.169.25a.711.711 0 0 0-.262.212.358.358 0 0 0-.05.225l.006-.006Z" })
      ]
    }
  );
}
SalesCenter.tidalIconMeta = {
  categories: "miscellaneous,services,common",
  name: "SalesCenter"
};
validateTidalLicense();
export {
  SalesCenter
};
//# sourceMappingURL=SalesCenter.js.map
